module.exports = __webpack_public_path__ + "img/hotdog_panameno.9e18b068.jpeg";